var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qx-auto-complete',{attrs:{"disabled":_vm.disabled,"fetch-suggestions":_vm.termSearch,"orderDefaultValue":_vm.defaultValue,"value-key":_vm.itemName,"placeholder":"请选择合同条款"},on:{"select":_vm.selectItem},model:{value:(_vm.supplierValue),callback:function ($$v) {_vm.supplierValue=$$v},expression:"supplierValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }